module.exports = __webpack_public_path__ + "static/2-4878a51a9ad4a712fd0fae4af1550870.png";